const loadingButton = (isLoading, object, originalClass, OriginalText) => {
    if (isLoading) {
        object.children[0].classList = ''
        object.children[0].classList = 'spinner-border spinner-border-sm'
        object.setAttribute('disabled','disabled')
        object.lastChild.nodeValue = ' Aguarde...'
    } else {
        object.children[0].classList = ''
        if (originalClass)
            object.children[0].classList = originalClass
        else 
            object.children[0].classList = 'fa fa-save'
        object.removeAttribute('disabled')
        if (OriginalText)
            object.lastChild.nodeValue = ' ' + OriginalText
        else
            object.lastChild.nodeValue = ' Salvar'
    }
    object.classList.toggle('cursor-wait')
}


export const defaultButton = (props) => {
    return (
        <>
            {props.download &&
                < button className="w-26 bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center m-1" onClick={props.onClick}>
                    <svg className="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" /></svg>
                    <span>Download</span>
                </button>}

            {(props.save || props.ok) &&
                // <button className="w-24 bg-gradient-to-r from-gray-500 to-gray-400 text-white hover:from-gray-900 text-blue-700 font-semibold hover:text-white py-2 px-4 rounded-lg" onClick={props.onClick}>
                <button className="w-24 bg-gradient-to-r from-sky-800 to-blue-600 hover:from-gray-900 py-2 px-4 border text-white font-semibold rounded-lg m-2" onClick={props.onClick}>
                    {props.save ? "Salvar" : "Ok"}
                </button>}

            {props.close &&
                <button className="w-24 bg-gradient-to-r from-gray-600 to-gray-400 text-white hover:from-gray-900 text-blue-700 font-semibold hover:text-white py-2 px-4 rounded-lg" onClick={props.onClick}>
                    Fechar
                </button>}
        </>
    );
}




export default loadingButton